import { render, staticRenderFns } from "./IRReportsAndPresentationsPage.vue?vue&type=template&id=5f9d5968"
import script from "./IRReportsAndPresentationsPage.vue?vue&type=script&lang=js"
export * from "./IRReportsAndPresentationsPage.vue?vue&type=script&lang=js"
import style0 from "./IRReportsAndPresentationsPage.vue?vue&type=style&index=0&id=5f9d5968&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports